import { Component, effect, input } from '@angular/core';

@Component({
  selector: 'casi-counter',
  standalone: true,
  imports: [],
  templateUrl: './counter.html',
  styleUrl: './counter.scss'
})
export class Counter  {
  value = input(10, {
    alias: "counter",
    transform: (value:number) => value * 100
  });

  constructor() {
    effect((onCleanup) => {
      console.log(`New Value: ${this.value()}`);
      onCleanup(() => {
        console.log(`Perform cleanup action here...`);
      })
    })
  }

}
